import { render } from "./aluno-add-turma.vue?vue&type=template&id=7821fba4&scoped=true"
import script from "./aluno-add-turma.vue?vue&type=script&lang=js"
export * from "./aluno-add-turma.vue?vue&type=script&lang=js"

import "./aluno-add-turma.vue?vue&type=style&index=0&id=7821fba4&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7821fba4"]])

export default __exports__